module.exports = __webpack_public_path__ + "img/abstract2.0400cc3.jpg";